import React, {Component} from 'react'
import SectionWrapper from "../../sectionwrapper.component.jsx";

class LineSeparatorContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12">
                    <hr className={"border-color-light-gray"} />
                </div>
            </SectionWrapper>
        );
    }
}

export default LineSeparatorContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/line-separator/section.component.jsx